module.exports = __webpack_public_path__ + "img/usp_icon2.f8098f0d.svg";